// extracted by mini-css-extract-plugin
export default {"center":"Wishlist_center__XQkBu","wishlist_product":"Wishlist_wishlist_product__3WSut","message":"Wishlist_message__9ez42"};